export default "__VITE_ASSET__lBYvAZ4N__"